import { connectRouter } from 'connected-react-router';
import { APP_CONTROLLER_REDUCERS } from '@bit/gerenciatd.unifiedcomponents.app-controller';
import { combineReducers } from '../components/AppController';
import homeReducer from './home';
import fusionReducer from './fusion';
import filtersReducer from './filters';
import selectReducer from './select';

const rootReducers = (history) => combineReducers({
  router: connectRouter(history),
  context: APP_CONTROLLER_REDUCERS.context,
  home: homeReducer,
  fusion: fusionReducer,
  filters: filtersReducer,
  select: selectReducer,
  errorCatcher: APP_CONTROLLER_REDUCERS.errorCatcher,
});

export default rootReducers;
